import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options, label, desktop }) {
    return (
        <div className={`ns-relative ${desktop ? "ns-sort-desktop" : "ns-sort-mobile"}`}>
            <h2 class="facet-filters__label caption-large text-body">
                <label for={`nosto-${label?.split(' ')?.join('-')}`}>Sort by:</label>
            </h2>
            <div class="select">
                <select
                    className={`ns-selection-dropdown-menu ns-text-align-left ns-font-1 ${className}`}
                    value={value}
                    onChange={onChange}
                    aria-label={label || "Select"}
                    id={`nosto-${label?.split(' ')?.join('-')}-${desktop ? 'desktop' : 'mobile'}`}
                >
                    {options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
                <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                    </path>
                </svg>
            </div>
        </div>
    )
}
